import type { GiayBaoCo, GiayBaoCoInput } from '@/types/schemas/giay-bao-co.type';
import { useAuth } from '@/contexts/auth-context';
import { QUERY_KEYS } from '@/constants';
import api from '@/lib/api';

interface UseGiayBaoCoMutationParams {
  formMode: string;
  selectedObj: GiayBaoCo | null;
  addItem: (data: GiayBaoCoInput) => Promise<GiayBaoCo>;
  updateItem: (uuid: string, data: GiayBaoCoInput) => Promise<GiayBaoCo>;
  deleteItem: (uuid: string) => Promise<unknown>;
  handleCloseForm: () => void;
  clearSelection: () => void;
  refreshData: () => Promise<unknown>;
}

export const useGiayBaoCoMutation = ({
  formMode,
  selectedObj,
  addItem,
  updateItem,
  deleteItem,
  handleCloseForm,
  clearSelection,
  refreshData
}: UseGiayBaoCoMutationParams) => {
  const { entity } = useAuth();

  const handleSubmit = async (data: GiayBaoCoInput) => {
    if (formMode === 'add') {
      await addItem(data);
    } else if (formMode === 'edit' && selectedObj?.uuid) {
      await updateItem(selectedObj.uuid, data);
    }

    handleCloseForm();
    clearSelection();
    await refreshData();
  };

  const handleBulkDelete = async (uuids: string[]) => {
    await api.post(`/entities/${entity?.slug}/erp/${QUERY_KEYS.GIAY_BAO_CO}/bulk-delete/`, {
      list: uuids
    });
    await refreshData();
  };

  return {
    handleSubmit,
    handleDelete: deleteItem,
    handleBulkDelete
  };
};
